module.exports = __webpack_public_path__ + "img/emilie-name.7a07fb47.png";